module.exports = __webpack_public_path__ + "static/media/cnrfp.1ee02631.png";